/**
 * Copyright (c) 2020-21 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { useEffect, useRef, useState } from 'react';
// eslint-disable-next-line
export function useBehavior(s) {
    var _a = useState({}), next = _a[1];
    var current = useRef();
    current.current = s === null || s === void 0 ? void 0 : s.value;
    useEffect(function () {
        if (!s) {
            return;
        }
        var sub = s.subscribe(function (v) {
            if (current.current !== v)
                next({});
        });
        return function () { return sub.unsubscribe(); };
    }, [s]);
    return s === null || s === void 0 ? void 0 : s.value;
}
//# sourceMappingURL=use-behavior.js.map